import { Routes, Route } from "react-router-dom";
import RequireAdmin from "./components/RequireAdmin";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import Pipeline from "./pages/Pipeline";
import Logs from "./pages/Logs";
import Records from "./pages/Records";
import PlaceDetail from "./pages/PlaceDetail";
import EventDetail from "./pages/EventDetail";
import CorrectionDetail from "./pages/CorrectionDetail";
import Review from "./pages/Review";
import Organizers from "./pages/Organizers";
import EntityRoles from "./pages/EntityRoles";
import EntityClaimApprovals from "./pages/EntityClaimApprovals";
import ContentModeration from "./pages/ContentModeration";
import PublishedContent from "./pages/PublishedContent";
import Promotions from "./pages/Promotions";
import Users from "./pages/Users";
import AiModels from "./pages/AiModels";
import SystemHealth from "./pages/SystemHealth";

// Route table. Everything except /login is wrapped in RequireAdmin (client-side
// UX gate — the real authorization is each edge fn's requireAdmin) and Layout
// (sidebar + <Outlet/>). Keep the paths in sync with lib/nav.ts.
export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <RequireAdmin>
            <Layout />
          </RequireAdmin>
        }
      >
        <Route path="/" element={<Home />} />
        <Route path="/pipeline" element={<Pipeline />} />
        <Route path="/logs" element={<Logs />} />
        <Route path="/records" element={<Records />} />
        <Route path="/records/places/:id" element={<PlaceDetail />} />
        <Route path="/records/events/:id" element={<EventDetail />} />
        <Route path="/records/corrections/:id" element={<CorrectionDetail />} />
        <Route path="/review" element={<Review />} />
        <Route path="/organizers" element={<Organizers />} />
        <Route path="/entity-roles" element={<EntityRoles />} />
        <Route path="/entity-claim-approvals" element={<EntityClaimApprovals />} />
        <Route path="/content-moderation" element={<ContentModeration />} />
        <Route path="/published-content" element={<PublishedContent />} />
        <Route path="/promotions" element={<Promotions />} />
        <Route path="/users" element={<Users />} />
        <Route path="/ai-models" element={<AiModels />} />
        <Route path="/system-health" element={<SystemHealth />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
